import { DataService } from "base/services";
import { useAccountStore } from "base/stores";
import { USER_TYPES } from "base/constants";

import { getApiBaseUrl } from "../utils/service.utils.js";

const ACCOUNTS_SERVICE = "accounts";

export const AdminService = {
  // account Details

  getAccount() {
    const url = getApiBaseUrl(ACCOUNTS_SERVICE);
    return DataService.get(url);
  },

  getAccountDetails() {
    const ACCOUNT_ID_URL = "/id";
    return DataService.get(ACCOUNT_ID_URL);
  },

  saveAccount(accountData) {
    const url = getApiBaseUrl(ACCOUNTS_SERVICE);
    return DataService.update(url, {
      data: accountData
    });
  },

  getAdminList(filter = "") {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/user/2/${accountId}?page_number=1&page_size=50`, {
      query: { q: filter, _user_type: USER_TYPES.ADMIN }
    });
  },

  getAllUsers(searchText = "") {
    const { _id } = useAccountStore.getState();
    return DataService.get(
      `/user/2/${_id}?page_number=1&page_size=50&invited_user=false`,
      {
        query: { q: searchText }
      }
    );
  },

  getFieldList() {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/user/2/${accountId}/fields`);
  },

  getAppContext() {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/signin/2/${accountId}/context`);
  },

  transferOwner(params) {
    const accountId = useAccountStore.getState()._id;
    return DataService.update(`/accounts/2/${accountId}/owner`, {
      data: params
    });
  },

  // domain settings Services

  updateDomainDetails(domain) {
    const accountId = useAccountStore.getState()._id;
    return DataService.post(`/accounts/2/${accountId}/domain`, {
      data: domain
    });
  },

  domainResendMail(domainId) {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(
      `/accounts/2/${accountId}/domain/${domainId}/resend`
    );
  },

  deleteDomain(domainId) {
    const accountId = useAccountStore.getState()._id;
    return DataService.delete(`/accounts/2/${accountId}/domain/${domainId}`);
  },

  saveAccountSecurity(securityData, isEnforceEmail = false, isSingleSignOn) {
    const url = getApiBaseUrl(ACCOUNTS_SERVICE);
    return DataService.post(`${url}/auth/setting`, {
      data: {
        ...securityData,
        ...(isSingleSignOn && { SendLoginEnforceMail: isEnforceEmail })
      }
    });
  },

  deleteSAMLSetting() {
    const accountId = useAccountStore.getState()._id;
    return DataService.delete(`/accounts/2/${accountId}/auth/setting/saml`);
  },

  // holiday Services
  // accounts/2/<account_id>/admin

  deleteHoliday(date) {
    const url = getApiBaseUrl(ACCOUNTS_SERVICE);
    return DataService.delete(`${url}/admin/holiday/${date}`);
  },

  createHoliday(holidayList) {
    const url = getApiBaseUrl(ACCOUNTS_SERVICE);
    return DataService.post(`${url}/admin/holiday`, {
      data: holidayList
    });
  },

  updateHoliday(holidayList) {
    const url = getApiBaseUrl(ACCOUNTS_SERVICE);
    return DataService.post(`${url}/admin/holiday/${holidayList.Date}`, {
      data: holidayList
    });
  },

  updateWeekend(weekendList) {
    const url = getApiBaseUrl(ACCOUNTS_SERVICE);
    return DataService.post(`${url}/admin/weekend/`, {
      data: weekendList
    });
  },

  async getFavIcon(domain) {
    let response = await fetch(`https://favicongrabber.com/api/grab/${domain}`);
    let result = await response.json();
    let _iconsData = result.icons;

    return Array.isArray(_iconsData) && _iconsData.length > 0
      ? _iconsData[0].src
      : null;
  },

  holidayDetails({ Start, End, WeekEnds }) {
    const url = getApiBaseUrl(ACCOUNTS_SERVICE);
    return DataService.get(`${url}/admin/holiday`, {
      query: { Start, End, WeekEnds }
    });
  },

  fileSettings(data) {
    return DataService.update(
      `/accounts/2/${useAccountStore.getState()._id}/attachment/preference/`,
      {
        data
      }
    );
  },

  saveLocationApiKey(key) {
    const url = getApiBaseUrl(ACCOUNTS_SERVICE);
    return DataService.update(`${url}/geolocation/apikey`, {
      data: {
        GeolocationApiKey: key
      }
    });
  },

  uploadXML(data) {
    const accountId = useAccountStore.getState()._id;
    return DataService.post(`/signin/2/${accountId}/saml/parse/idp`, {
      data
    });
  },

  getSAMLMetadata() {
    const accountId = useAccountStore.getState()._id;
    return DataService.download(`/signin/2/${accountId}/saml/download/sp`);
  },

  getOauthClient(clientId) {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(
      `/accounts/2/${accountId}/admin/oauth2/client/${clientId}`
    );
  }
};
